export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Query operada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Ocorreu um erro ao criar a query.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  QUERY_ERROR: {
    SUCCESS: {
      variant: "default",
      description: "",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Comandos do tipo 'TRUNCATE' ou 'DROP' não são permitidos.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  CREATE_FAVORITE: {
    SUCCESS: {
      variant: "default",
      description: "Query favorita salva com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Ocorreu um erro ao criar a query favorita.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  NO_WHERE: {
    SUCCESS: {
      variant: "default",
      description: "",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Comandos sem 'WHERE' não são permitidos.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Analistas atualizados com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar analistas.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DISABLED: {
    SUCCESS: {
      variant: "default",
      description: "Operação realizada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao realizar a operação!",
      duration: 5000,
      closeOnClick: true,
    },
  },
  EDIT_QUERY: {
    SUCCESS: {
      variant: "default",
      description: "Query editada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao editar a query!",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DELETE_QUERY: {
    SUCCESS: {
      variant: "default",
      description: "Query deletada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao deletar a query!",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
